import {useEffect, useRef} from "react";
import './ContextMenu.scss'

export type ContextMenuItem = {
    label: string
    onClick: () => void
    danger?: boolean
}

type Props = {
    x: number
    y: number
    items: ContextMenuItem[]
    onClose: () => void
}

const MENU_WIDTH = 172

export default ({ x, y, items, onClose }: Props) => {
    const menuRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const onDown = (e: MouseEvent | TouchEvent) => {
            if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
                onClose()
            }
        }
        const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
        const onScroll = () => onClose()

        window.addEventListener('mousedown', onDown)
        window.addEventListener('touchstart', onDown)
        window.addEventListener('keydown', onKey)
        window.addEventListener('scroll', onScroll, { passive: true })

        return () => {
            window.removeEventListener('mousedown', onDown)
            window.removeEventListener('touchstart', onDown)
            window.removeEventListener('keydown', onKey)
            window.removeEventListener('scroll', onScroll)
        }
    }, [onClose])

    const itemHeight = 40
    const menuHeight = items.length * itemHeight + 8
    const adjX = Math.min(x, window.innerWidth - MENU_WIDTH - 8)
    const adjY = y + menuHeight > window.innerHeight ? Math.max(8, y - menuHeight) : y

    return (
        <div className="context-menu" ref={menuRef} style={{ left: adjX, top: adjY }}>
            {items.map((item, i) => (
                <button
                    key={i}
                    className={'cm-item' + (item.danger ? ' cm-danger' : '')}
                    onClick={() => { item.onClick(); onClose() }}
                >
                    {item.label}
                </button>
            ))}
        </div>
    )
}
